import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const CaretRightIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 45 80" {...props}>
      <path
        fill={fill}
        d="M40.5001406,0.4995737 C42.3618549,0.4995737 44.2235692,1.1756987 45.6429978,2.5279487 L78.3698549,33.6814487 C81.2098549,36.3848237 81.2098549,40.7678237 78.3698549,43.4723237 C75.5298549,46.1756987 70.9252835,46.1756987 68.0852835,43.4723237 L40.5001406,17.2136987 L12.9161406,43.4723237 C10.0761406,46.1756987 5.4704263,46.1756987 2.6304263,43.4723237 C-0.2095737,40.7678237 -0.2095737,36.3848237 2.6304263,33.6814487 L35.3572835,2.5279487 C36.7778549,1.1756987 38.6395692,0.4995737 40.5001406,0.4995737"
        transform="rotate(90 23 22.5)"
      />
    </Icon>
  );
};

CaretRightIcon.propTypes = {
  fill: PropTypes.string,
};

export default CaretRightIcon;
